import { useTranslation } from 'next-i18next'
import useOrder from 'modules/order/state/order/use-order'
import useDrawer from 'modules/drawer/state/use-drawer'
import { ListItem } from 'modules/ui/atoms/ListItem'
import useConfig from 'modules/config/state/use-config'

export const ORDER_DEDICATION_DRAWER_OPENER_DATA_ID = 'order-dedication-drawer-opener'

const OrderDedicationDrawerOpener = () => {
  const { t } = useTranslation()
  const config = useConfig()
  const drawer = useDrawer()
  const order = useOrder()

  const dedication = order.dedication.value

  if (!config.dedication.isEnabled) {
    return null
  }

  const subtitle = dedication.honoreeName
    ? t('orderDedicationDrawerOpener.subtitle', {
        defaultValue: 'In {{type}} of {{honoreeName}}',
        type: dedication.type,
        honoreeName: dedication.honoreeName,
      })
    : ''

  const color = config.theme['--theme-color__brand-primary'] || ''

  return (
    <ListItem
      color={color}
      label={t('orderDedicationDrawerOpener.label', 'Dedicate your Donation')}
      subtitle={subtitle}
      icon="dedication"
      dataId={ORDER_DEDICATION_DRAWER_OPENER_DATA_ID}
      onClick={() => drawer.open('dedication')}
      isDrawerComplete={!!subtitle}
    />
  )
}

export default OrderDedicationDrawerOpener
